import React, { useState } from 'react';
import { Sidebar, Sidenav, Navbar, Nav } from 'rsuite';
import AngleLeftIcon from '@rsuite/icons/legacy/AngleLeft';
import AngleRightIcon from '@rsuite/icons/legacy/AngleRight';
import { useNavigate } from 'react-router-dom';
import { ROLE } from './components/USER';
import { getNavLinks } from './nav-links';

const headerStyles = {
  padding: 18,
  fontSize: 16,
  height: 56,
  background: '#34c3ff',
  color: '#fff',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

const NavToggle = ({ expand, onChange }) => (
  <Navbar appearance="inverse" className="nav-toggle">
    <Nav pullRight>
      <Nav.Item onClick={onChange} style={{ width: 56, textAlign: 'center' }}>
        {expand ? <AngleLeftIcon /> : <AngleRightIcon />}
      </Nav.Item>
    </Nav>
  </Navbar>
);

const SideBar = () => {
  const [expand, setExpand] = useState(true);
  const [selected, setSelected] = useState('1');
  const navigate = useNavigate();
  const role = ROLE();
  const links = getNavLinks(role);

  return (
    <Sidebar
      style={{
        display: 'flex',
        flexDirection: 'column',
        background: '#051e34',
        height: '100vh',
        overflow: 'hidden',
        overflowY: 'auto',
      }}
      width={expand ? 260 : 56}
      collapsible
    >
      <Sidenav.Header>
        <div style={headerStyles}>
          <span style={{ marginLeft: 12 }}>Admin Panel</span>
        </div>
      </Sidenav.Header>
      <Sidenav expanded={expand} appearance="inverse" style={{ background: '#051e34' }}>
        <Sidenav.Body>
          <Nav>
            {links.map((item) =>
              item.type === 'normal' ? (
                <Nav.Item
                  key={item.eventKey}
                  onSelect={(eventKey) => setSelected(eventKey)}
                  active={item.eventKey === selected}
                  eventKey={item.eventKey}
                  icon={item.icon}
                  onClick={() => navigate(item.path)}
                >
                  {item.name}
                </Nav.Item>
              ) : (
                <Nav.Menu
                  key={item.eventKey}
                  eventKey={item.eventKey}
                  trigger="hover"
                  title={item.name}
                  icon={item.icon}
                  placement="rightStart"
                >
                  {item.items.map((sub) => (
                    <Nav.Item
                      key={sub.eventKey}
                      onSelect={(eventKey) => setSelected(eventKey)}
                      active={sub.eventKey === selected}
                      eventKey={sub.eventKey}
                      icon={sub.icon}
                      onClick={() => navigate(sub.path)}
                    >
                      {sub.name}
                    </Nav.Item>
                  ))}
                </Nav.Menu>
              )
            )}
          </Nav>
        </Sidenav.Body>
      </Sidenav>
      <NavToggle expand={expand} onChange={() => setExpand(!expand)} />
    </Sidebar>
  );
};

export default SideBar;